<template>
  <div class="jewelleryHK">
    <div class="login">
      <div class="loginBg">
        <img ref="loginBg"
             src="https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/self_service/web_login_bg_RP4_f4zu_8A-unsplash.png"
             alt="">
      </div>
      <div class="loginMask">
        <div class="loginBox">
          <div class="loginTitle">
            {{ $t('mall_login.phone_login') }}<!-- 手機登錄 -->
          </div>
          <div>
            {{ $t('mall_home.account_num') }}<!-- 帳號 -->
          </div>
          <div class="mobile">
            <el-select @change="getCode" v-model="areaCode" :placeholder="$t('mall_login.area_num')"
                       :disabled="disabled">
              <el-option value="852" label="+852"></el-option>
              <el-option value="86" label="+86"></el-option>
            </el-select>
            <div class="phoneN">
              <img :src="require('@/assets/homeImg/dl_icon_zhanghao@2x.png')" alt="">
              <input @change="getCode" id="phoneNumber" v-model="phoneNumber" type="text"
                     :placeholder="$t('mall_login.input_phone')" :disabled="disabled">
            </div>
          </div>
          <div class="vertifyCode">
            <input id="imgCode" @keyup="getCode" maxlength="4" v-model="imgCode" type="text"
                   :placeholder="$t('mall_login.input_code')" :disabled="disabled">
            <img @click="getImgCode" :src="imgData.img" alt="">
          </div>
          <div class="passwordTitle">
            <span>
             {{ $t('mall_login.phone_pwd') }} <!-- 手機驗證碼 -->
            </span>
          </div>
          <div class="password">
            <img :src="require('@/assets/homeImg/dl_icon_mima@2x.png')" alt="">
            <input maxlength="6" v-model="code" type="text" :placeholder="$t('mall_login.input_phone_pwd')"
                   @keyup.enter="toLogin">
          </div>
          <div class="fotgotP"><a style="cursor: pointer" @click="resetImgCode"
                                  :class="{'resend': !disabled || resendTime > 0}">
            {{ $t('mall_login.code_resend') }}<!-- 沒收到驗證碼？重新發送 -->
            {{ resendTime > 0 ? '(' + resendTime + ')' : '' }}</a></div>
          <div class="loginNow" @click="toLogin"><span>
            {{ $t('mall_home.login') }}<!-- 登錄 -->
          </span></div>
        </div>
      </div>
    </div>
    <div style="margin-bottom: 60px"></div>
  </div>

</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      countDown: null,
      resendTime: 0,
      areaCode: '852',
      phoneNumber: '',
      imgCode: '',
      code: '',
      disabled: false,
      // area: 440300,
      isShow: false,
      imgData: {
        key: '',
        img: '',
      },
    }
  },
  methods: {
    toLogin() {
      if (this.phoneValidator() && this.codeValidator()) {
        this.$axios.post('mall_api/login', {
          area_code: this.areaCode,
          username: this.phoneNumber,
          sms_verification_code: this.code,
        }).then(res => {
          this.$notify.success({
              title: this.$t('mall_login.success'),// '成功',
              message:  this.$t('mall_login.success_login'),// '登錄成功'
            }
          );
          var token = res.data.data.token_type + ' ' + res.data.data.access_token;
          this.$store.state.token = token;
          this.$store.state.user.mobile = this.phoneNumber;
          localStorage.setItem('Authorization', token);
          localStorage.setItem('UserInfo', JSON.stringify({mobile: this.phoneNumber}));
          let beforeUrl = this.$route.query.redirect;
          if (res.data.data.is_new_user) {
            this.$router.replace({name: 'SelfPage'});
          } else if (beforeUrl) {
            this.$router.replace({path: beforeUrl});
          } else {
            this.$router.replace({path: '/'});
          }
        });
      }
    },
    getImgCode() {
      this.$axios.get('mall_api/login/captcha', {}).then(res => {
        this.imgData = res.data.data.url;
      }).catch(error => {
        this.$notify.error({
          title: this.$t('mall_login.error'),//'錯誤',
          message: error.message
        });
      });
    },
    resetImgCode() { //重填圖形驗證碼
      if (this.disabled && this.resendTime === 0) {
        clearInterval(this.countDown);
        let that = this;
        that.resendTime = 30;
        that.countDown = setInterval(function () {
          that.resendTime -= 1
        }, 1000);
        this.disabled = false;
        this.getImgCode();
        this.imgCode = '';
        $('#imgCode').focus();
      }
    },
    getCode() {
      if (this.imgCode && this.imgCode.length === 4) {
        if (this.phoneValidator()) {
          this.disabled = true;
          this.$axios.post('mall_api/login/sms', {
            captcha_key: this.imgData.key,
            captcha: this.imgCode,
            mobile: this.phoneNumber,
            area_code: this.areaCode,
          }).then(res => {
            this.$notify.success({
              title: this.$t('mall_login.success'),// '成功',
              message: this.$t('mall_login.message_has_sent')// '短信驗證碼已發送'
            });
          }).catch(error => {
            let that = this;
            setTimeout(function () {
              that.disabled = false;
            }, 2000);
            $('#imgCode').focus();
          });
        }
      }
    },
    phoneValidator() {
      if (!this.phoneNumber) {
        this.$notify.error({
          title: this.$t('mall_login.error'),//'錯誤',
          message: this.$t('mall_login.input_phone') //'請填寫手機號'
        });
        $('#phoneNumber').focus();
        return false;
      } else if ((this.areaCode === '86') && !(/^1[3456789]\d{9}$/.test(this.phoneNumber))) {
        this.$notify.error({
          title: this.$t('mall_login.error'),//'錯誤',
          message: this.$t('mall_login.error_phone') //'手機號碼有誤，請重填'
        });
        $('#phoneNumber').focus();
        return false;
      } else if ((this.areaCode === '852') && !(/^(5|6|8|9)\d{7}$/.test(this.phoneNumber))) {
        this.$notify.error({
          title: this.$t('mall_login.error'),//'錯誤',
          message: this.$t('mall_login.error_phone') //'手機號碼有誤，請重填'
        });
        $('#phoneNumber').focus();
        return false;
      } else {
        return true;
      }
    },
    codeValidator() {
      if (!this.code || this.code.length < 6) {
        this.$notify.error({
          title: this.$t('mall_login.error'),//'錯誤',
          message: this.$t('mall_login.error_phone_pwd') //'請填寫正確的手機驗證碼'
        });
      } else {
        return true;
      }
    }
  },
  mounted() {
  },
  created() {
    if (this.$store.getters.token) {
      this.$router.replace({path: '/'});
    }
    this.getImgCode();
  }
}
</script>

<style lang="less" scoped>

/deep/ .el-select {
  /*line-height: 60px;*/
  padding: 10px 10px 10px 0;
  line-height: 1;
  flex: 1;
}

.loginBg {
  width: 100%;
}

.login {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.loginBg > img {
  width: 100%;
}

.loginMask {
  box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 28px;
  right: 80px;
  width: 395px;
  overflow: hidden;
}

.loginBox {
  /*height: 100%;*/
  background-color: #fff;
  padding: 30px 40px;
  color: #5B5957;
  font-size: 14px;

}

.loginTitle {
  color: #3E3C39;
  font-size: 20px;
  padding-bottom: 20px;
  /*padding: 20px 40px;*/
}

.mobile {
  display: flex;
}

.phoneN {
  flex: 2.7;
  position: relative;
}

.phoneN > img {
  width: 18px;
  height: 21px;
  position: absolute;
  top: 50%;
  margin-top: -14px;
  left: 10px;
}


input {
  background-color: #f7f5f1;
  width: 100%;
  height: 40px;
  border: 1px solid #BBBBBB;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

input::-webkit-input-placeholder { /* WebKit browsers */
  color: #979694;
}

input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: #979694;
}

input::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #979694;
}

input:-ms-input-placeholder { /* Internet Explorer 10+ */
  color: #979694;
}

.vertifyCode {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.vertifyCode > input {
  flex: 2;
  margin-right: 20px;
  padding-left: 10px;
}

.vertifyCode > img {
  width: 120px;
  height: 40px;
  background-color: #f00;
}

.phoneN > input {
  /*width: 100%;*/
  padding-left: 35px;
  margin-top: 10px;
  margin-bottom: 20px;
  color: #979694;
}

.passwordTitle > img {
  width: 18px;
  height: 8px;

}

.passwordTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px 15px 0;
}

.password {
  position: relative;
}

.password > input {
  padding-left: 35px;
}

.password > img {
  width: 18px;
  height: 22px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
  left: 10px;
}

.fotgotP {
  text-align: right;
  text-decoration: underline;
  padding: 5px;
}

.loginNow {
  cursor: pointer;
  background-color: #1E1303;
  color: #fff;
  /*height: 50px;*/
  /*line-height: 50px;*/
  line-height: 1;
  padding: 18px 0;
  text-align: center;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-top: 30px;
}

.createAccount > a {
  display: block;
  width: 100%;
  height: 100%;
}

.resend {
  color: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/views/viewHK/Login.vue